import { AppsMenuItem } from '@/interfaces/AppsMenuItem';
import i18n from '@/plugins/i18n/i18n';
import { urls } from '@/shared/urls';

export const constants = {
	consentUnauthorized: 'GENERAL_TERMS_AGREEMENT' as string,
	// change it during local development
	// devEnvUrl: 'https://mtelbab2csc.wm.rs',
	devEnvUrl: 'https://b2csc-qa.mtel.ba',
	defaultDeviceType: 'WEB',
	notAuthPages: [
		'login',
		'registration',
		'registrationConfirmation',
		'registrationLinkExpired',
		'forgottenPassword',
		'passwordConfirmation',
		'forgottenPasswordLinkExpired',
		'newPassword',
		'passwordChanged',
		'changeEmailLinkExpired',
	] as string[],
	profileTitle: 'Profile' as string,
	profilePages: [
		'linkedAccounts',
		'changeEmail',
		'deleteAccount',
		'changePassword',
	] as string[],
	billsPages: [
		'billsOverview',
		'eBillsOverview',
		'activationOnWord',
		'payBillForAnother',
	] as string[],
	servicesPages: [
		'mobilePrepaidOverview', 'changeTariff', 'topUp', 'tariffOptions', 'prepaidNumbers', 'parkingPrepaid', 'personalOfferPrepaid', 'overviewAppsPrepaid',
		'mobilePostpaidOverview', 'postpaidTopUp', 'additionalServices', 'changeTariffPostpaid', 'postpaidTariffOptions', 'postpaidNumbers', 'personalOfferPostpaid', 'overviewAppsPostpaid',
		'mobilePostpaidOverviewPackage', 'postpaidTopUpPackage', 'additionalServicesPackage', 'changeTariffPostpaidPackage', 'postpaidTariffOptionsPackage', 'postpaidNumbersPackage', 'personalOfferPostpaidPackage', 'overviewAppsPostpaidPackage',
		'internetOverview', 'changeTariffInternet', 'personalOfferInternet', 'overviewAppsInternet',
		'kombinujOverview', 'kombinujTopUp', 'combineTariffOptions', 'combineNumbers', 'parkingCombine', 'personalOfferCombine', 'overviewAppsCombine',
		'additiveNetOverview', 'additiveNetTopUp', 'additiveTariffOptions', 'parkingAdditive', 'personalOfferAdditive', 'overviewAppsAdditive',
		'tvOverview', 'tvChannels', 'additionalStbDevices', 'tvToGo', 'tvToGoConfirmation', 'tvToGoSuccess', 'iptvShop', 'personalOfferTv', 'overviewAppsTv',
		'msatOverview', 'msatChannels', 'msatAddons', 'msatAdditionalStbDevices', 'overviewAppsMsat',
		'fixedTelephonyOverview', 'fixedTelephonyTariffOptions', 'fixedNumbers', 'personalOfferFixed', 'overviewAppsFixed',
	] as string[],
	applicationPages: [
		'siguranNetOverview',
		'apollonOverview', 'apollonUserGuide',
		'arenaCloudOverview', 'arenaCloudUserGuide',
		'balkanMusicOverview', 'balkanMusicUserGuide',
		'deezerOverview', 'deezerUserGuide',
		'nbaOverview', 'nbaUserGuide',
		'mtelStore',
		'listOfApps',
	] as string[],
	supportPages: [
		'request',
		'complaint',
		'incident',
	] as string[],
	modals: {
		activateService: 'activate-service',
		deactivateService: 'deactivate-service',
		activateTariffOption: 'activate-tariff-option',
		deactivateTariffOption: 'deactivate-tariff-option',
		activateUssdTariffOption: 'activate-ussd-tariff-option',
		activateSmsTariffOption: 'activate-sms-tariff-option',
		addDevice: 'add-device',
		removeDevice: 'remove-device',
		// ref for activation on word
		activateBarringConnectedService: 'activate-barring-connected-service',
		// refs for favourite numbers
		addFavouriteNumber: 'add-favourite-number',
		addEnteredFavouriteNumber: 'add-entered-favourite-number',
		deactivateFavouriteOption: 'deactivate-favourite-option',
		// refs for favourite numbers
		addEnteredDearestNumber: 'add-entered-dearest-number',
		deactivateDearestOption: 'deactivate-dearest-option',
		// refs for friend numbers
		addNumber: 'add-number',
		removeNumber: 'remove-number',
		editNumber: 'edit-number',
		// refs for bills
		allBills: 'show-bills',
		// refs for ebills
		activateEBill: 'activate-e-bill',
		deactivateEBillFirstStep: 'deactivate-e-bill-first',
		deactivateEBillSecondStep: 'deactivate-e-bill-second',
		// refs for tv to go
		deleteAccount: 'delete-account',
		deleteDevice: 'delete-device',
		// ref for tv addons
		activateAddonWithChannels: 'activate-addon-channels',
		// ref for parking
		addNewCarNumber: 'add-new-car-number',
		removeCarNumber: 'remove-car-number',
		payForParking: 'pay-for-parking',
		tariffCharacteristics: 'tariff-characteristics',
		dynamicModal: 'dynamic-modal',
		// digital services
		activateAddon: 'activate-addon',
		successfulActivated: 'successfulActivated',
		deactivateAddon: 'deactivate-addon',
		changeAddon: 'change-addon',
		// register
		userNotFound: 'register-user-not-found',
		b2bUser: 'register-b2b-user',
		// personal offers
		offerActivationModal: 'offer-activation-modal',
		personalOfferAddon: 'personal-offer-addon',
		personalOfferPre2Post: 'personal-offer-pre-2-post',
		// tv banner modal
		iptvShopModal: 'iptv-shop',
		iptvHBOModal: 'iptv-hbo',
		// support
		sendRequest: 'send-request',
		// unpaid bills
		unpaidBills: 'unpaid-bills',
	} as { [key: string]: string },
	storage: {
		nav: 'nav',
		user: 'user',
		userToken: 'userToken',
		userId: 'userId',
		tvUser: 'tvUser',
		subscriberIdentity: 'subscriberIdentity',
		isShowedSnackbar: 'isShowedSnackbar',
		registrationType: 'registrationType',
		isAfterLogin:  'isAfterLogin',
	} as { [key: string]: string },
	globalUrls: {
		selfcare: 'https://moj.mtel.ba',
		commerce: 'https://mtel.ba',
		b2bAppIos: 'https://apps.apple.com/us/app/m-go-bih/id940374073',
		b2cAppIos: 'https://apps.apple.com/app/id1423516571',
		b2bAppAndroid: 'https://play.google.com/store/apps/details?id=ba.mtel.mgo&hl=sr',
		b2cAppAndroid: 'https://play.google.com/store/apps/details?id=ba.mtel.moj&hl=sr&gl=US',
		b2bAppHuawei: 'https://appgallery.huawei.com/#/app/C101204951',
		b2cAppHuawei: 'https://appgallery.huawei.com/#/app/C101202013',
		personalOfferTopup: 'https://mtel.ba/elektronska-dopuna',
		hboMax: 'https://auth.max.com/login',
	} as { [key: string]: string },
	observerDebounceTime: 300 as number,
	eventsTypes: {
		getOverviewNavigation: 'get-overview-navigation',
		getHeaderInfo: 'get-header-info',
		emitProfileHeaderInfo: 'profile-header-info',
		emitUpdateCustomers: 'update-customers',
		emitGetTariffOptions: 'get-tariff-option',
		emitGetDetails: 'get-details',
		emitUpdateAccountHeader: 'emit-update-account-info',
		getAppsNavigation: 'get-app-navigation',
		updatePersonalOffer: 'update-personal-offer',
		updatePromoTvBanner: 'update-promo-banner',
		openAddServiceModal: 'open-add-service-modal',
	} as { [key: string]: string },
	favouriteOptionCode: 'omiljeni-broj',
	dearestOptionCode: 'najdrazi-broj',
	deactivatedStatuses: [
		'Suspended',
		'Isključen u oba smjera',
		'Isključen odlaz',
		'Zabrana odlaznih poziva',
	],
	digitalServices: [
		{
			title: i18n.t('message.sigurannet.title'),
			url: urls.siguranNetOverview,
			isConstant: false,
			subItems: [
				{
					title: i18n.t('message.apps.overview'),
					url: urls.siguranNetOverview
				},
			]
		},
		{
			title: i18n.t('message.apollon.title'),
			url: urls.apollonOverview,
			isConstant: false,
			subItems: [
				{
					title: i18n.t('message.apps.overview'),
					url: urls.apollonOverview
				},
				{
					title: i18n.t('message.apps.userGuide'),
					url: urls.apollonUserGuide
				}
			]
		},
		{
			title: i18n.t('message.arenacloud.title'),
			url: urls.arenaCloudOverview,
			isConstant: false,
			subItems: [
				{
					title: i18n.t('message.apps.overview'),
					url: urls.arenaCloudOverview
				},
				{
					title: i18n.t('message.apps.userGuide'),
					url: urls.arenaCloudUserGuide
				}
			]
		},
		{
			title: i18n.t('message.balkan.title'),
			url: urls.balkanMusicOverview,
			isConstant: false,
			subItems: [
				{
					title: i18n.t('message.apps.overview'),
					url: urls.balkanMusicOverview
				},
				{
					title: i18n.t('message.apps.userGuide'),
					url: urls.balkanMusicUserGuide
				}
			]
		},
		{
			title: i18n.t('message.deezer.title'),
			url: urls.deezerOverview,
			isConstant: false,
			subItems: [
				{
					title: i18n.t('message.apps.overview'),
					url: urls.deezerOverview
				},
				{
					title: i18n.t('message.apps.userGuide'),
					url: urls.deezerUserGuide
				}
			]
		},
		{
			title: i18n.t('message.nba.title'),
			url: urls.nbaOverview,
			isConstant: false,
			subItems: [
				{
					title: i18n.t('message.apps.overview'),
					url: urls.nbaOverview
				},
				{
					title: i18n.t('message.apps.userGuide'),
					url: urls.nbaUserGuide
				}
			]
		},
		{
			title: i18n.t('message.mtelStore.title'),
			url: urls.mtelStore,
			isConstant: false,
		},
		{
			title: 'm:tel aplikacije',
			url: urls.listOfApps,
			isConstant: true,
		}
	] as AppsMenuItem[],
	additionalNavItems: [
		{
			icon: 'icon-phone',
			title: i18n.t('message.apps.additionalNavItems[0]'),
			description: '0800 50 000',
			url: 'tel:080050000',
		},
		{
			icon: 'icon-letter',
			title: i18n.t('message.apps.additionalNavItems[1]'),
			description: 'korisnicka.podrska@mtel.ba',
			url: 'mailto:korisnicka.podrska@mtel.ba',
		},
		{
			icon: 'icon-roaming',
			title: i18n.t('message.apps.additionalNavItems[2]'),
			description: 'mtel.ba',
			url: 'https://mtel.ba/',
		}
	],
	supportItems: [
		{
			title: i18n.t('message.support.submitRequest'),
			url: urls.request,
		},
		{
			title: i18n.t('message.support.complaints'),
			url: urls.complaint,
		},
		{
			title: i18n.t('message.support.incidentReport'),
			url: urls.incident,
		},
	] as AppsMenuItem[],
	tvOverviewPhones: {
		IPTV: '080050000',
		MSAT: '0800 50905',
	} as { [key: string]: string },
	reCaptchaTestKey: '6LfAIJoUAAAAAPZZYYQwyCa6KqlHL8TSlHjXJxL-',
};

export const SIGURAN_NET_OPTION_CODE = 'option-sigurannet';
